import {
  Copy,
  Heading,
  Image,
  Link,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { BalanceOnboardingButton } from 'src/components/selfService/features/Signup/steps/ValidationStep/components/BalanceOnboardingButton';
import {
  statesContent,
  supportEmail,
} from 'src/components/selfService/features/Signup/steps/ValidationStep/constants';
import { ValidationStepStateComponentProps } from 'src/components/selfService/features/Signup/steps/ValidationStep/ValidationStep.utils';

export function RejectedState({
  onboardingUrl,
}: ValidationStepStateComponentProps): JSX.Element {
  const { rejected } = statesContent;

  const { isPhone } = useScreenSizes();
  const textAlign = isPhone ? 'left' : 'center';

  return (
    <>
      <Stack y="sm" alignSelf="center">
        <Image
          width="250px"
          src={rejected.illustrationUrl}
          alt=""
          role="presentation"
        />
      </Stack>
      <Stack y="sm">
        <Heading variant="h1" textAlign={textAlign}>
          {rejected.title}
        </Heading>
      </Stack>
      <Stack y="sm">
        <Copy variant="body" textAlign={textAlign} display="inline-block">
          {rejected.text[0]}
        </Copy>
      </Stack>
      <Stack y="sm">
        <Copy variant="body" textAlign={textAlign} display="inline-block">
          {rejected.text[1]}
        </Copy>
      </Stack>
      <Stack y="md">
        <Copy variant="body" textAlign={textAlign} display="inline-block">
          {rejected.text[2]}{' '}
          <Link variant="muted" href={`mailto:${supportEmail}`}>
            {supportEmail}
          </Link>
        </Copy>
      </Stack>
      <BalanceOnboardingButton
        text={rejected.onboardingButtonText}
        href={onboardingUrl}
        disabled={!onboardingUrl}
        buttonSize="small"
      />
    </>
  );
}
